import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import TermsOfService from './TermsOfService';
import PrivacyPolicyContent from './PrivacyPolicyContent';
import HonorCode from './HonorCode';
import CommunityGuidelines from './CommunityGuidelines';
import CopyrightInfringement from './CopyrightInfringement';
import '../styles/styles.css';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const PrivacyPolicy = () => {
    const [value, setValue] = React.useState(0);
    const location = useLocation();
    const isMobile = useMediaQuery('(max-width:768px)');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    React.useEffect(() => {
        setValue(0);
    }, [location]);

    return (
        <div className="privacy-policy-page">
            <Box
                sx={{
                    width: '100%',
                    maxWidth: 1200,
                    margin: '0 auto',
                    paddingTop: 0,
                }}
            >
                <Typography variant="h6" gutterBottom>
                    Policies
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' }, // Mobile: column, Desktop: row
                        gap: 2,
                        minHeight: 'calc(100vh - 140px)',
                    }}
                >
                    {/* LEFT: VERTICAL TABS */}
                    <Box
                        className="privacy-left-nav"
                        sx={{
                            minWidth: { xs: '100%', md: '220px' },
                            flexShrink: 0,
                            borderRight: { md: 1, xs: 0 },
                            borderBottom: { xs: 1, md: 0 },
                            borderColor: 'divider',
                            pb: { xs: 1, md: 0 },
                        }}
                    >
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            orientation={isMobile ? 'horizontal' : 'vertical'}
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="policy tabs"
                            sx={{
                                '& .MuiTab-root': {
                                    justifyContent: 'flex-start',
                                    textAlign: 'left',
                                    fontWeight: 500,
                                    color: 'text.primary',
                                    opacity: 0.7,
                                    '&.Mui-selected': {
                                        opacity: 1,
                                        fontWeight: 600,
                                        color: 'primary.main',
                                    },
                                },
                            }}
                        >
                            <Tab label="Terms of Service" id="vertical-tab-0" />
                            <Tab label="Privacy Policy" id="vertical-tab-1" />
                            <Tab label="Integrity Pledge" id="vertical-tab-2" />
                            <Tab label="Learning Code" id="vertical-tab-3" />
                            <Tab label="Copyright" id="vertical-tab-4" />
                        </Tabs>
                    </Box>

                    {/* RIGHT: CONTENT */}
                    <Box sx={{ flex: 1, overflow: 'auto' }}>
                        <TabPanel value={value} index={0}><TermsOfService /></TabPanel>
                        <TabPanel value={value} index={1}><PrivacyPolicyContent /></TabPanel>
                        <TabPanel value={value} index={2}><HonorCode /></TabPanel>
                        <TabPanel value={value} index={3}><CommunityGuidelines /></TabPanel>
                        <TabPanel value={value} index={4}><CopyrightInfringement /></TabPanel>
                    </Box>
                </Box>
            </Box>
        </div>
    );
};

export default PrivacyPolicy;